import { useQueryStates, parseAsInteger } from 'nuqs'

export const useReviewFiltersQueryState = () => {
  const queryStates = useQueryStates(
    {
      workId: parseAsInteger,
      shiftId: parseAsInteger,
      companyId: parseAsInteger,
      companyGroupId: parseAsInteger,
      workerId: parseAsInteger,
    },
    {
      urlKeys: {
        workId: 'work-id',
        shiftId: 'shift-id',
        companyId: 'company-id',
        companyGroupId: 'company-group-id',
        workerId: 'worker-id',
      },
    }
  )

  return queryStates
}
